import logo from "assets/graphics/logo.png";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="text-center my-4">
      <Link to="/">
        <img
          src={logo}
          className="img-fluid"
          style={{
            height: "150px",
          }}
          alt="Agnieszka i Bartosz"
        />
      </Link>
    </header>
  );
};

export default Header;
